import { Assistant } from '@/types';
import automotiveIcon from '../assets/skautoGPTforme Favicon.svg'
import {assistantsService, convertApiAssistant} from "@/api/services/assistants.service.ts";


export const loadAssistants = async (): Promise<Record<string, Assistant>> => {
    try {
        const apiAssistants = await assistantsService.getPublishedAssistants();

        if (apiAssistants.length === 0) {
            console.log('No API assistants found');
            return {}; // Return empty object instead of defaults
        }

        const dynamicAssistants: Record<string, Assistant> = {};

        // Only use API assistants, no defaults
        apiAssistants.forEach(apiAssistant => {
            const assistant = convertApiAssistant(apiAssistant);
            console.log('Converted assistant:', assistant.id, assistant);

            dynamicAssistants[apiAssistant.id] = assistant;
        });

        console.log('Loaded assistants from API:', dynamicAssistants);
        return dynamicAssistants;
    } catch (error) {
        console.error('Failed to load assistants from API:', error);
        return {}; // Return empty object on error instead of defaults
    }
};

// Export initial assistants (will be updated dynamically)
export let ASSISTANTS: Record<string, Assistant> = {};

